import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState, ViewType } from '../types';
import { useStorymapStore } from '../useModule';
import { InitStorymap } from './initStorymap';
import { getActiveCard, getTrackingVisibleCardIds, isSubtask } from '../use';

const { registerMiddleware, registerReducer, dispatch } = useStorymapStore();

export class ForceRefreshStorymap extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ForceRefreshStorymap';

    public constructor() {
        super(ForceRefreshStorymap.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState): Promise<boolean> => {
    const activeCard = getActiveCard();
    const preferredTrackingCardId =
        state.currentViewType === ViewType.Tracking &&
        isSubtask(activeCard) &&
        getTrackingVisibleCardIds(state, state.trackingViewState.releaseId).includes(activeCard.id)
            ? activeCard.id
            : null;

    await dispatch(new InitStorymap(state.slug, null, null, state.trackingViewState.releaseId, true, preferredTrackingCardId));
    return true;
};

const reducer = async (): Promise<boolean> => {
    return true;
};

//@ts-ignore
registerMiddleware(ForceRefreshStorymap.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ForceRefreshStorymap.ACTION_TYPE, reducer);
